import React, { useEffect } from 'react';
import './Zatca.css';

const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000); // Auto-close after 5 seconds

    return () => {
      clearTimeout(timer);
    };
  }, [onClose]);

  return (
    <div className="toast-notification">
      <div className="toast-content">
        <div className="toast-icon">✓</div>
        <div className="toast-message">{message}</div>
      </div>
      <button onClick={onClose} className="toast-close-btn">×</button>
      <div className="toast-progress-bar"></div>
    </div>
  );
};

export default Toast; 